import { listItemsType } from 'src/components/common/CustomSelect'
import { Icon } from 'src/assets/svg/Icon'
import styled, { css } from 'styled-components'
import { Noto_body3_b12, Noto_body3_r12, Noto_heading3_b20 } from 'src/styles/fonts/NotoSansKrFonts'
import { BottomSheetProps } from 'src/components/layout/MainLayout/MainBottomSheet'
import React from 'react'
import { Container } from 'src/components/common/Container'
import { Typography } from 'src/components/common/Typography'
import { CustomSwiper } from 'src/components/common/CustomSwiper'

export type bottomSheetSortType = 0 | 1 | 2 | 3

const selectListItems: listItemsType<bottomSheetSortType>[] = [
  { text: '임박기간', value: 0 },
  { text: '최근구매', value: 1 },
  { text: '즐겨찾기', value: 2 },
  { text: '직접등록', value: 3 },
]

const MainBottomSheetHeader = ({
  bottomSheetToggle,
  couponSortOrder,
  bottomSheetCouponSortHandler,
  bottomSheetHeaderReloadHandler,
}: Pick<
  BottomSheetProps,
  | 'bottomSheetToggle'
  | 'couponSortOrder'
  | 'bottomSheetHeaderReloadHandler'
  | 'bottomSheetCouponSortHandler'
>) => {
  return (
    <S.MainBottomHeader.Container>
      <S.MainBottomHeader.TopContainer $option="flex_row">
        <Typography $fontStyle={Noto_heading3_b20} $color="var(--white)">
          쿠폰사용
        </Typography>
        <S.MainBottomHeader.IconButtonWrap $option={'flex_row'}>
          <S.MainBottomHeader.IconButton>
            <Icon.Reload onClickFn={bottomSheetHeaderReloadHandler} size={'38'} />
          </S.MainBottomHeader.IconButton>
          <S.MainBottomHeader.IconButton>
            <Icon.BlackX onClickFn={bottomSheetToggle} size={'38'} />
          </S.MainBottomHeader.IconButton>
        </S.MainBottomHeader.IconButtonWrap>
      </S.MainBottomHeader.TopContainer>
      <S.MainBottomHeader.SortWrap $option="flex_row" $column_gap="6px">
        <S.MainBottomHeader.SortTitle $fontStyle={Noto_body3_b12} $color="var(--white)">
          정렬기준
        </S.MainBottomHeader.SortTitle>
        <CustomSwiper.Wrap type="default" $wrapstyle={S.MainBottomHeader.ChipsSwiperStyle} gap={3}>
          {selectListItems?.map((el: listItemsType<bottomSheetSortType>) => (
            <CustomSwiper.Item
              key={el.value}
              $itemstyle={S.MainBottomHeader.ChipsSwiperItemsStyle(couponSortOrder === el.value)}
              onClick={() => bottomSheetCouponSortHandler(el.value)}
            >
              {el.text}
            </CustomSwiper.Item>
          ))}
        </CustomSwiper.Wrap>
      </S.MainBottomHeader.SortWrap>
    </S.MainBottomHeader.Container>
  )
}
export default MainBottomSheetHeader

const S = {
  MainBottomHeader: {
    Container: styled.div`
      padding: 0 20px;
    `,
    TopContainer: styled(Container)`
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 38px;
    `,
    SortWrap: styled(Container)`
      align-items: center;
      width: 100%;
      margin-top: 7px;
    `,
    SortTitle: styled(Typography)`
      word-break: keep-all;
    `,
    ChipsSwiperStyle: css`
      width: 100%;
    `,
    ChipsSwiperItemsStyle: (isSelect: boolean) => css`
      ${isSelect ? Noto_body3_b12 : Noto_body3_r12};
      padding: 4px 10px;
      border-radius: 100px;
      border: 1px solid ${isSelect ? 'var(--brand-70)' : 'var(--black-80)'};
      color: ${isSelect ? 'var(--brand-50)' : 'var(--black-40)'};
      ${isSelect && 'background: var(--black-100)'};
    `,
    IconButton: styled(Container)`
      width: 38px;
    `,
    IconButtonWrap: styled(Container)`
      width: fit-content;
    `,
  },
}
